export const setPathWS = () => {
    if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
      return 'http://192.168.1.33/';
    } else {
      return window.location.origin + '/';
    }
  };
export const POST_ATTACHMENTS= './GalateaWS/api/Attachments';